import i18next from "i18next"
import React from "react"

export const EmptyDeviceList = ({ t, style }: { t: typeof i18next.t, style?: React.CSSProperties }) => {
  return <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', ...style }}>
    <img />
    <p style={{ fontFamily: 'Montserrat', color: '#677486', fontSize: 16, textAlign: 'center' }}>{t('ENROLLMENT.EMPTY_MESSAGE')}</p>
  </div>
}